import BaseNode from "./BaseNode";

class BaseShortMeter extends BaseNode {
    
    private _expendables: number[];
    private _version: number;
    private _reference: string;
    private _installationDate: Date;
    private _color: string;
    private _address: string;
    private _provider: string;
    private _contract: string;
    private _tariff: string;
    private _supplyPointNumber: string;
    private _raepceNumber: string;
    private _contractNumber: string;

    public constructor(id: string, name: string, invariant: string, objectType: string, location: string, depreciated: boolean, expendables: number[], version: number, reference: string, installationDate: Date, color: string, address: string, provider: string, contract: string, tariff: string, supplyPointNumber: string, raepceNumber: string, contractNumber: string) {
        super(id, name, invariant, objectType, location, depreciated);
        this._expendables = expendables;
        this._version = version;
        this._reference = reference;
        this._installationDate = installationDate;
        this._color = color;
        this._address = address;
        this._provider = provider;
        this._contract = contract;
        this._tariff = tariff;
        this._supplyPointNumber = supplyPointNumber;
        this._raepceNumber = raepceNumber;
        this._contractNumber = contractNumber;
    }

    //** Energies */
    public get Expendables(): number[] {
        return this._expendables;
    }
    public set Expendables(value: number[]) {
        this._expendables = value;
    }

    //** Version */
    public get Version(): number {
        return this._version;
    }
    public set Version(value: number) {
        this._version = value;
    }

    //** Reference */
    public get Reference(): string {
        return this._reference;
    }
    public set Reference(value: string) {
        this._reference = value;
    }

    //** Date d'installation */
    public get InstallationDate(): Date {
        return this._installationDate;
    }
    public set InstallationDate(value: Date) {
        this._installationDate = value;
    }

    /** Couleur */
    public get Color(): string {
        return this._color;
    }
    public set Color(value: string) {
        this._color = value;
    }

    /** Adresse */
    public get Address(): string {
        return this._address;
    }
    public set Address(value: string) {
        this._address = value;
    }

    /** Fournisseur */
    public get Provider(): string {
        return this._provider;
    }
    public set Provider(value: string) {
        this._provider = value;
    }

    /** Contrat */
    public get Contract(): string {
        return this._contract;
    }
    public set Contract(value: string) {
        this._contract = value;
    }

    /** Tarif */
    public get Tariff(): string {
        return this._tariff;
    }
    public set Tariff(value: string) {
        this._tariff = value;
    }

    /** Numéro de point de livraison */
    public get SupplyPointNumber(): string {
        return this._supplyPointNumber;
    }
    public set SupplyPointNumber(value: string) {
        this._supplyPointNumber = value;
    }

    /** Numéro de RAEPCE */
    public get RaepceNumber(): string {
        return this._raepceNumber;
    }
    public set RaepceNumber(value: string) {
        this._raepceNumber = value;
    }

    /** Numéro de contrat */
    public get ContractNumber(): string {
        return this._contractNumber;
    }
    public set ContractNumber(value: string) {
        this._contractNumber = value;
    }
}

export default BaseShortMeter;